var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.364,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3decd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28348b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_214",
    "data-name": "Groupe 214",
    transform: "translate(-335.628 -1591.147)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(335.628 1591.147)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_299",
    "data-name": "Trac\\xE9 299",
    d: "M14.817,4.236a5.265,5.265,0,0,0-.335-1.748A3.691,3.691,0,0,0,12.374.38,5.278,5.278,0,0,0,10.626.045C9.855.009,9.61,0,7.654,0s-2.2.008-2.969.042A5.266,5.266,0,0,0,2.937.377a3.515,3.515,0,0,0-1.278.833,3.547,3.547,0,0,0-.83,1.275A5.279,5.279,0,0,0,.494,4.233C.457,5,.449,5.249.449,7.205s.008,2.2.042,2.969a5.264,5.264,0,0,0,.335,1.748,3.69,3.69,0,0,0,2.108,2.108,5.279,5.279,0,0,0,1.748.335c.768.034,1.013.042,2.969.042s2.2-.008,2.969-.042a5.263,5.263,0,0,0,1.748-.335,3.685,3.685,0,0,0,2.108-2.108,5.282,5.282,0,0,0,.335-1.748c.034-.768.042-1.013.042-2.969s0-2.2-.037-2.969Zm-1.3,5.882a3.949,3.949,0,0,1-.248,1.337A2.39,2.39,0,0,1,11.9,12.823a3.963,3.963,0,0,1-1.337.248c-.76.034-.988.042-2.91.042S5.5,13.1,4.746,13.071a3.947,3.947,0,0,1-1.337-.248,2.217,2.217,0,0,1-.827-.538,2.24,2.24,0,0,1-.538-.827A3.964,3.964,0,0,1,1.8,10.121c-.034-.76-.042-.988-.042-2.91S1.763,5.058,1.8,4.3a3.947,3.947,0,0,1,.248-1.337,2.19,2.19,0,0,1,.54-.828A2.237,2.237,0,0,1,3.412,1.6a3.966,3.966,0,0,1,1.337-.248c.76-.034.988-.042,2.91-.042s2.153.008,2.91.042a3.949,3.949,0,0,1,1.337.248,2.215,2.215,0,0,1,.827.538,2.239,2.239,0,0,1,.538.828A3.965,3.965,0,0,1,13.52,4.3c.034.76.042.988.042,2.91s-.008,2.148-.042,2.907Zm0,0",
    transform: "translate(343.678 1598.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_300",
    "data-name": "Trac\\xE9 300",
    d: "M128.562,124.5a3.613,3.613,0,1,0,3.613,3.613A3.614,3.614,0,0,0,128.562,124.5Zm0,5.956a2.343,2.343,0,1,1,2.343-2.343A2.344,2.344,0,0,1,128.562,130.456Zm0,0",
    transform: "translate(222.771 1477.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_301",
    "data-name": "Trac\\xE9 301",
    d: "M364.222,89.488a.886.886,0,1,1-.886-.886A.886.886,0,0,1,364.222,89.488Zm0,0",
    transform: "translate(-8.169 1512.545)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.14e945d35226cf2d57c61f8d5aeb7ee9.svg";
export { ForwardRef as ReactComponent };